module.exports = __webpack_public_path__ + "static/media/1016956.cb0a59ab.jpg";